import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from './api.service';
import {LocalStorageService} from 'ngx-webstorage';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import {environment} from '../../../environments/environment';
import {Subject} from 'rxjs/Subject';
import {MessagingService} from './messaging.service';
import {VnaPortalSelected} from '../data/messaging/VnaPortalSelected';
import {WebSocketService} from './web-socket-service';

import * as _ from 'underscore';

@Injectable()
export class AuthService {

    private last_request: string;
    private default_url = 'dashboard';
    private token: string;
    private user: Object = {};
    private portalDefault: string = "";
    private allowedPortals: Array<Object> = [];
    private profiles: Array<string> = [];

    constructor(private route: Router, private api: ApiService, private localStorage: LocalStorageService, private messaging: MessagingService, private ws: WebSocketService) {
        this.messaging.message.subscribe(
            (value: any) => {
                if(value instanceof VnaPortalSelected){
                    this.localStorage.store('vna_last_portal_selected', value);
                }
            }
        );
    }

    initUser(params) {
        this.token = params.token;

        this.initUserData(params);
        this.initPortalDefault(params);
        this.initWs(params.user);

        // Set Token for Api
        this.localStorage.store(environment['token_storage'], {'token': this.token, 'bo_user_pk': this.user['pk']});
        this.api.setToken(this.token);

        // Redirect to dashboard o last page
        //const url_dest = (typeof this.last_request === 'undefined') ? this.default_url : this.last_request;
        const url_dest = this.default_url;
        this.route.navigate([url_dest]);
    }

    initUserData(params: Object) {
        this.user = params['user'];
        this.allowedPortals = params['app_portals'];
        let profilesSecondary = (params['app_portal_default']['profile_secondary'].length > 0) ? JSON.parse(params['app_portal_default']['profile_secondary']) : [];
        profilesSecondary.forEach( (profile: string) => {
          this.profiles.push(profile);
        })
        this.profiles.push(params['app_portal_default']['profile_main']);
    }

    initPortalDefault(params: Object): void {
        let lastPortalSelected = this.localStorage.retrieve('vna_last_portal_selected');
        this.portalDefault = (lastPortalSelected) ? lastPortalSelected['portal'] : params['app_portal_default']['portal'];
    }

    initWs(user: Object) {
        if(!this.ws.isConnected()){
            this.ws.connectClient(user['email']);
        }
    }

    canAccess(urlRequest: string): boolean | Observable<boolean> {
        this.last_request = urlRequest;
        if (this.token) {
            return true;
        } else {
            const tokenObject = this.localStorage.retrieve(environment['token_storage']);
            if (tokenObject && tokenObject.hasOwnProperty('token')) {
                this.api.setToken(tokenObject.token);
                return this.api.get('bo_user/' + tokenObject.bo_user_pk, {'check': 1}).map(
                    (authResponse) => {
                        if (authResponse.hasOwnProperty('user')) {
                            this.initUserData(authResponse);
                            this.initPortalDefault(authResponse);
                            this.initWs(authResponse['user']);
                            return true;
                        }
                        this.redirectToLogin();
                        return false;
                    }
                );
            }
        }
        this.redirectToLogin();
        return false;
    }

    redirectToLogin() {
        return this.route.navigate([environment.login_page])
    }

    destroy(): Promise<boolean> {
        this.localStorage.clear(environment['token_storage']);
        this.ws.close(this.user['email']);
        this.token = undefined;
        this.user = {};
        return this.redirectToLogin();
    }

    getUser(): object {
        return this.user;
    }

    getClient(): number {
      return this.user['vna_client_pk'];
    }

    getPortalDefault(): string {
        return this.portalDefault;
    }

    getPortalSelected(): VnaPortalSelected {
        return this.localStorage.retrieve('vna_last_portal_selected');
    }

    getPkPortal(): number{
        return this.localStorage.retrieve('vna_last_portal_selected').pkPortal;
    }

    getAllowedPortals(): Array<Object> {
        return this.allowedPortals;
    }

    getProfiles(): Array<string> {
        return this.profiles;
    }

    isAdmin(): boolean {
        return (_.indexOf(this.profiles, 'admin') >= 0);
    }
}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/auth.service.ts